import {
    accentColorValues,
    blue,
    green,
    indigo,
    joulelingo,
    kilosight,
    orange,
    pink,
    purple,
    red,
    teal
} from './colors.js'

const primaryPresets = {
    blue,
    green,
    indigo,
    joulelingo,
    kilosight,
    orange,
    pink,
    purple,
    red,
    teal
}

export const getPrimary = (preset) => {
    const resolvedPreset = primaryPresets[preset]
    if (resolvedPreset) return resolvedPreset

    console.error(
        `Invalid color preset, accepted values: ${accentColorValues
            .map((value) => `"${value}"`)
            .join(', ')}.`
    )
    return blue
}

// 'site' is the default accent: the domain's own brand colour on joulelingo.com and
// kilosight.com, and pink everywhere else. Any other value is a choice the user made.
export const SITE_COLOR_PRESET = 'site'
const SITE_PRESETS = { joulelingo: 'joulelingo', kilosight: 'kilosight' }

export const resolveColorPreset = (preset, brandKey) =>
    !preset || preset === SITE_COLOR_PRESET
        ? (SITE_PRESETS[brandKey] ?? 'pink')
        : preset
